import { render, staticRenderFns } from "./RoleListing.vue?vue&type=template&id=38f8d190&"
import script from "./RoleListing.vue?vue&type=script&lang=js&"
export * from "./RoleListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports